import React, { useState, useEffect, useRef, useContext } from 'react'
import { injectIntl } from 'react-intl'
import { Form, Input, Button, Modal } from 'antd'

import PCAlipayHK from './PC'
import H5AlipayHK from './H5'
import myContext from '@/utils/createContext'

const FormItem = Form.Item

const AlipayHK = props => {
    const { payMethods, urlParams, payData, infoData, intl } = props;
    const { isMobileView, loading, actualPaymentAmount, setLoading, actualPaymentCurrency, publicKey, key, token, type, checkPolling, orderStatus } = useContext(myContext)

    console.log(type);
    return (
        <myContext.Provider value={{
            payMethods,
            urlParams,
            isMobile: isMobileView,
            checkPolling,
            payData,
            infoData,
            setLoading,
            intl,
            loading,
            actualPaymentAmount,
            actualPaymentCurrency,
            publicKey,
            key,
            token,
            type,
            checkPolling,
            orderStatus
        }}>
            {isMobileView ? <H5AlipayHK /> : <PCAlipayHK />}
        </myContext.Provider>
    )
}

export default injectIntl(AlipayHK)
